module.exports = __webpack_public_path__ + "static/media/landing-layer2.e68b3b98.png";